import { fromJS, List, Map, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { chartFactory } from '../../charts/chart.helper';
import { ITyped } from '../../shared/interfaces/typed.interface';
import { DashboardComponentTypesEnum } from '../reports.enum';
import { DashboardList } from './dashboard-list.model';
import { Filter } from './filter.model';
import { Link } from './link.model';
import { Summary } from './summary.model';
import { Tab } from './tab.model';
import { Text } from './text.model';

export const CARD_SCHEMA = Object.freeze({
  TYPE: '',
  TITLE: null, // string
  FILTERS: List<Filter>([]),
  GROUPS: List<number>([]),
  CONTENT: List<ITyped>([]),
});
const RECORD = generateSchema(CARD_SCHEMA);
const KEYS: any = generateKeys(CARD_SCHEMA);

export class Card extends Record(RECORD) implements ITyped {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.FILTERS,
        value: props.get(KEYS.FILTERS)
          ? this.filters.map((params) => new Filter(params))
          : List<Filter>([]),
      },
      {
        key: KEYS.CONTENT,
        value: props.get(KEYS.CONTENT)
          ? props
              .get(KEYS.CONTENT)
              .map((params) => this._cardContentFactory(params))
          : List<ITyped>([]),
      },
    ]);

    return selfModel as Card;
  }

  get type(): string {
    return DashboardComponentTypesEnum.card;
  }

  get title(): string {
    return this.get(KEYS.TITLE);
  }

  get filters(): List<Filter> {
    return this.get(KEYS.FILTERS);
  }

  get groups(): List<number> {
    return this.get(KEYS.GROUPS);
  }

  get content(): List<ITyped> {
    return this.get(KEYS.CONTENT);
  }

  private _cardContentFactory(props: Map<string, any>): ITyped {
    const entryType: string = props.get('type');
    const componentType = entryType;

    switch (componentType) {
      case DashboardComponentTypesEnum.link:
        return new Link(props);
      case DashboardComponentTypesEnum.list:
        return new DashboardList(props);
      case DashboardComponentTypesEnum.summary:
        return new Summary(props);
      case DashboardComponentTypesEnum.tab:
        return new Tab(props);
      case DashboardComponentTypesEnum.text:
        return new Text(props);
    }

    try {
      return chartFactory(props);
    } catch (error) {
      throw new Error(`Unsupported dashboard component type: ${entryType}.`);
    }
  }
}
